export default __webpack_public_path__ + "static/media/icn-close.3503fc04.svg";